import { Environment } from '../../../config';
import request from '../../../utils/request';
import * as Types from '../types';

interface IApplicant {
  applicant_id: number;
  username: string;
  applicant_name: string;
  isVerified: boolean;
  intermidiary: number;
  vat_num: string;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IApplicantListOutput {
  items: IApplicant[];
  paging: IPaging;
}

interface IApplicantListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}

export const fetchApplicants = async (
  payload: IApplicantListInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/applicant/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`
  );
  let _data: IApplicantListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

interface IResendVerificationLinkInput {
  applicant_id: number;
}

export const resendVerificationLink = async (
  payload: IResendVerificationLinkInput
): Promise<Types.ResponseOutput> => {
  const data: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/applicant/${payload.applicant_id}/resend-verification-link`
  );
  // console.log(data);
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

interface IApplicantActiveRegistrations {
  applicant_id?: string;
}
export const fetchApplicantActiveRegistrations = async ({
  applicant_id,
}: IApplicantActiveRegistrations): Promise<Types.ResponseOutput> => {
  const query = applicant_id ? `?applicant_id=${applicant_id}` : '';
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/applicant/registration/active${query}`
  );
  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
